import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';

import OverlayModal from '../ContentSystem/components/OverlayModal/OverlayModal';
import * as Styled from './NotifyDialog.styled';

import NotifyDialogSuccess from './NotifyDialogSuccess';
import NotifyDialogForm from './NotifyDialogForm';
import { QuickViewContext } from '../QuickView/QuickView.context';

/**
 * A modal to allow users to sign up for notifications for when an out of stock product is re stocked
 */
const NotifyDialog = ({ onRequestClose, isOpen, ...productVariant }) => {
  const [isComplete, setIsComplete] = useState(false);
  const { isQuickView } = useContext(QuickViewContext);

  useEffect(() => {
    setIsComplete(false);
  }, [productVariant.sku]);

  const handleOnComplete = () => setIsComplete(true);
  const handleClose = () => onRequestClose();

  return (
    <OverlayModal
      modalType="peeking"
      onRequestClose={handleClose}
      isOpen={isOpen}
      header="Notify Me"
      size={isQuickView ? 'mega' : 'regular'}
      height={isQuickView ? '85vh' : 'auto'}
    >
      <Styled.NotifyDialog data-testid="NotifyDialog">
        <Styled.Inner>
          {isComplete ? (
            <NotifyDialogSuccess
              image={productVariant.image}
              onOkayClick={handleClose}
            />
          ) : (
            <NotifyDialogForm
              {...productVariant}
              onComplete={handleOnComplete}
            />
          )}
        </Styled.Inner>
      </Styled.NotifyDialog>
    </OverlayModal>
  );
};

NotifyDialog.propTypes = {
  /**
   * function to run when the modal is closed
   */
  onRequestClose: PropTypes.func,
  /**
   * `true` if the modal is open
   */
  isOpen: PropTypes.bool
};

NotifyDialog.defaultProps = {
  onRequestClose: undefined,
  isOpen: false
};

export default NotifyDialog;
